__turbopack_context__.v({
  "error-message": "textarea-module-scss-module__9Scltq__error-message",
  "field-wrapper": "textarea-module-scss-module__9Scltq__field-wrapper",
  "footer": "textarea-module-scss-module__9Scltq__footer",
  "forced-error": "textarea-module-scss-module__9Scltq__forced-error",
  "input": "textarea-module-scss-module__9Scltq__input",
  "input-centered": "textarea-module-scss-module__9Scltq__input-centered",
  "label": "textarea-module-scss-module__9Scltq__label",
  "label-centered": "textarea-module-scss-module__9Scltq__label-centered",
  "placeholder": "textarea-module-scss-module__9Scltq__placeholder",
  "wrapper": "textarea-module-scss-module__9Scltq__wrapper",
});
